import { render } from "./LanguageDialog.vue?vue&type=template&id=2543b6e6"
import script from "./LanguageDialog.vue?vue&type=script&lang=js"
export * from "./LanguageDialog.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bahramhasanov/_PHP/bouquet-new-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__